import { AfterViewInit, Component, DoCheck, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { VerticalBarChart } from '../../../models/charts/vertical-bar-chart';
import { SeriesData, transposeSeries } from '../dashboard.types';
import {
	SegmentedControlOption,
	SegmentedControlValue,
} from '../../../shared-components/custom-segmented-control/custom-segmented-control.component';
import { TranslateService } from '../../../services/translate/translate.service';

export type DocumentForecastChartType = 'line' | 'bar';

@Component({
	selector: 'app-document-forecast-chart',
	templateUrl: './document-forecast-chart.component.html',
	styleUrls: ['./document-forecast-chart.component.scss'],
	standalone: false,
})
export class DocumentForecastChartComponent implements OnInit, AfterViewInit, DoCheck {
	@Input() public chart: VerticalBarChart;
	@Input() public currency: string;

	@ViewChild('chartContainer') chartContainer!: ElementRef;

	public chartType: DocumentForecastChartType = 'line';
	public chartTypeOptions: SegmentedControlOption[] = [];
	public chartView: [number, number] = [1200, 400];
	public barResults: SeriesData[] = [];

	private lastResults: SeriesData[] | null = null;

	constructor(private translateService: TranslateService) {}

	ngOnInit(): void {
		this.chartTypeOptions = [
			{
				value: 'line',
				label: this.translateService.translate('dashboard-chart.line'),
				icon: 'fa-solid fa-chart-line',
			},
			{
				value: 'bar',
				label: this.translateService.translate('dashboard-chart.stackedBar'),
				icon: 'fa-solid fa-chart-simple',
			},
		];
	}

	ngAfterViewInit(): void {
		setTimeout(() => this.updateChartView(), 100);
	}

	ngDoCheck(): void {
		const results = this.chart?.Results ?? null;
		if (results !== this.lastResults) {
			this.lastResults = results;
			this.barResults = transposeSeries(results ?? []);
			setTimeout(() => this.updateChartView(), 100);
		}
	}

	@HostListener('window:resize')
	onResize(): void {
		this.updateChartView();
	}

	public onChartTypeChange(value: SegmentedControlValue): void {
		this.chartType = value.toString() === 'bar' ? 'bar' : 'line';
		setTimeout(() => this.updateChartView(), 100);
	}

	private updateChartView(): void {
		if (this.chartContainer?.nativeElement) {
			const containerWidth = this.chartContainer.nativeElement.offsetWidth;
			const padding = 32;
			const width = containerWidth > padding ? containerWidth - padding : 1000;
			this.chartView = [width, 400];
		}
	}
}

